import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { LicensesPage } from '../../LicensesPage';

export function HubLicensesPage() {
  return (
    <AuditWrapper>
      <LicensesPage />
    </AuditWrapper>
  );
}
